// extracted by mini-css-extract-plugin
module.exports = {"container":"uS","copyContainer":"vS","hidden":"wS"};